import { CompanyCreateRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const createRoute = {
  path: 'create',
  element: <CompanyCreateRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Create</span>,
  }),
};